module.exports = __webpack_public_path__ + "img/invoice-at-female-banner.f50d750b.png";